import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const holman = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      "Partnerwerkstaetten in Ihrer Naehe": "Holman Werkstätten in Ihrer Nähe",
      hero: {
        title: "<strong>Willkommen bei der Werkstatt-Buchung von {{organization}}</strong>",
        subtitle: null,
      },
      layout: {
        backText: "Zurück zu holman.com",
        navbar: {
          partnerLogo: {
            alt: "Holman",
          },
        },
      },
      linkToHome: "https://werkstatt.repareo.de/partner/holman",
    },
  },
};
